angular

	.module 'App.Repository'
	.factory 'PromotionBenefitProductsRepository', ['BaseRepository', (BaseRepository) ->
		class PromotionBenefitProductsRepository extends BaseRepository
			@resource = '/promotion_benefit_products'
			@isRestricted = true

			loadByPromotionCampaignId: (campaignId) ->
				query = @createQuery()

				query.criteria 'promotion_campaign_id', '=', campaignId
				query.with 'products'
				query.with 'product_variants'
				query.with 'products>product_variants'
				query.with 'products>product_categories'
				query.with 'products>product_variants>product_data'

				return @getEntities query

		return new PromotionBenefitProductsRepository()
	]
